import React from 'react';
import { Button as BaseButton, ButtonProps as BaseButtonProps } from 'antd';

const Button = (props: BaseButtonProps) => <BaseButton {...props} />;

export default Button;
